import * as ReactQuery from 'react-query';
import { InferQueryOptions } from 'services';
import { useReferralSource } from 'pages/ReferralDetails/useReferralSource';
import { getReferralAPI } from './api';

export const GET_REFERRAL_KEY = '@referrals/get-referral';

type UseGetReferralOptions = InferQueryOptions<typeof getReferralAPI> & {
  /**
   * Explicit override for the external-referral flag. When omitted, the hook
   * reads it from the URL via `useReferralSource()` so feature code never has
   * to thread the flag through component props.
   */
  isExternalReferral?: boolean;
};

export function useGetReferral(id = '', options?: UseGetReferralOptions) {
  const { isExternalReferral: isExternalFromUrl } = useReferralSource();
  const isExternalReferral = options?.isExternalReferral ?? isExternalFromUrl;

  const { data, isLoading, isError, refetch } = ReactQuery.useQuery(
    [GET_REFERRAL_KEY, id, isExternalReferral],
    () => getReferralAPI(id, isExternalReferral),
    {
      ...options,
      enabled:
        (options?.enabled !== undefined ? options.enabled : true) &&
        Boolean(id),
    }
  );

  return {
    referral: data,
    isLoading,
    isError,
    refetch,
  };
}
